import React from 'react';
import styles from 'Custom/ISIBar/ISIBar.module.scss';

export const ISI_INTRO = (
  <span className="firstPart" data-qa-tag="isi-intro-first-part">
    No debe usar NEXPLANON si está embarazada o cree que puede estarlo, tiene o ha tenido coágulos de sangre, tiene enfermedad hepática o un tumor de hígado, tiene sangrado vaginal sin motivo aparente, tiene o ha tenido cáncer de mama o algún otro cáncer sensible a la progestina (una hormona femenina) o es alérgica a algún componente de NEXPLANON.
  </span>
);

export const ISI_BAR_CONTENT = {
  ARIA: {
    openIndication: 'Abrir Indicación completa',
    openISI: 'Abrir Información de Seguridad Importante completa',
  },
  indicationTitle: 'Indicación',
  indicationIntro:
    'NEXPLANON es un anticonceptivo recetado para la prevención del embarazo por un período de hasta 5 años.',
  indicationMobile: (
    <>
      <span className={styles.highlight} data-qa-tag="indication-mobile">INDICACIÓN:</span> NEXPLANON es un
      anticonceptivo recetado para la prevención del embarazo por un período de
      hasta 5 años.
    </>
  ),
  isiTitle: 'Información de Seguridad Importante',
  isiIntro: ISI_INTRO,
  isiMobile: (
    <>
      <span className={styles.highlight} data-qa-tag="isi-mobile-informacion">
        INFORMACIÓN DE SEGURIDAD IMPORTANTE:
      </span>{' '}
      {ISI_INTRO}
    </>
  ),
};
